import { getPublicClient } from '@/api/client/public-client';
import { getHttpClient } from '@/api/client/http-client';
import type { NAInterfaceResponseObj, AccountOperationReqObj } from '@/api/models';

export interface AuthResponse {
  accessToken: string;
  accountUUID: string;
  userID: string;
  termsAndConditionsAccepted: boolean;
}

/**
 * Authenticate via the FastAPI UserPortal endpoint.
 * Sends username/password, receives a signed JWT token.
 */
export async function authenticate(
  username: string,
  password: string,
): Promise<AuthResponse> {
  const client = getPublicClient();
  const response = await client.post<AuthResponse>('/Authenticate', {
    username,
    password,
  });
  return response.data;
}

/**
 * Account operations (unauthenticated).
 * Used for: create account, forgot password, forgot username.
 */
export async function accountOperation(
  req: AccountOperationReqObj,
): Promise<NAInterfaceResponseObj> {
  const client = getPublicClient();
  // validateStatus: always resolve so 4xx responses return the body instead of throwing.
  // The caller checks resp.responseObj.httpStatusCode and resp.responseObj.responseEnum.
  const response = await client.post<NAInterfaceResponseObj>('/AccountOperations', req, {
    validateStatus: () => true,
  });
  return response.data;
}

/**
 * Authenticated account operations (requires JWT).
 * Used for: change password, delete account, change email.
 * The single AccountOperations endpoint handles both authenticated and
 * unauthenticated operations — the C# handler checks operationType.
 */
export async function authenticatedAccountOperation(
  req: AccountOperationReqObj,
): Promise<NAInterfaceResponseObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>('/Auth/AccountOperations', req);
  return response.data;
}
